export default __webpack_public_path__ + "static/media/results_icon_black.199c7570.svg";